/* WebComponentCartIcon component */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging -- disabled to allow to inherit from AbstractComponent */
import { Component, Element, h, Listen, Prop, State } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import CartIconTemplate from './cwc-cart-icon.template';
import { AbstractComponent } from '@cewe-designsystem/abstract';
import packageInfo from '../package.json';

@Component({
  tag: 'cwc-cart-icon',
  styleUrl: './cwc-cart-icon.scss',
  shadow: true,
})
export class CartIconComponent {
  /**
   * element
   */
  @Element() element: HTMLElement;
  @Prop() svgPath: string;
  @Prop() keyAccount: number;
  @Prop() operator: number;
  @Prop() cartLink: string;

  /**
   * shows the amount of articles in the shopping cart
   */
  @State()
  itemsCount: number = 0;

  componentWillLoad() {
    if (!this.cartLink) {
      this.cartLink = window.location.origin + '/checkout.html';
    }
    this.getQuantityFromStorage();
  }

  /**
   * Event thrown in checkout-ui when cart items have changed
   *
   * @docs
   * @event cart-info-update
   */
  @Listen('cart-info-update', { target: 'window' })
  listenToEvent(event: CustomEvent) {
    const itemsCount = event.detail.itemsCount;
    if (itemsCount) {
      this.itemsCount = itemsCount || 0;
    } else {
      this.getQuantityFromStorage();
    }
  }

  findSessionCartCookie() {
    const match = document.cookie.match('(^|;)\\s*' + `${this.keyAccount}_session_cart` + '\\s*=\\s*([^;]+)');
    return match ? match.pop() : null;
  }

  getQuantityFromStorage() {
    const sessionCartCookie = this.findSessionCartCookie();
    const itemsCountFromStorage: CartInfo = JSON.parse(localStorage.getItem('co.' + this.keyAccount + '.CART_INFO'));
    if (sessionCartCookie && itemsCountFromStorage != null && itemsCountFromStorage.validUntil > Date.now()) {
      this.itemsCount = itemsCountFromStorage.itemsCount;
    } else {
      this.itemsCount = 0;
    }
  }

  render() {
    return (
      <CartIconTemplate
        controller={this}
        version={packageInfo.version}
      />
    );
  }
}

Object.setPrototypeOf(CartIconComponent.prototype, AbstractComponent.prototype);

export interface CartIconComponent extends AbstractComponent {}

interface CartInfo {
  validUntil: number;
  itemsCount: number;
}
